import { ExternalDonationType } from 'generated/graphql';

export const SAVE = 'app/FeaturesPage/SAVE';
export const SAVE_SUCCESS = 'app/FeaturesPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/FeaturesPage/SAVE_FAILED';

export const FORM_IDENTIFIER = 'app/FeaturesPage';
export const key = 'app/FeaturesPage';

export const externalDonationTypeLabels: Record<ExternalDonationType, string> = {
  OutOfPocket: 'Cash / Credit Card / Check',
  DAF: 'Donor-Advised Fund (DAF)',
  InKind: 'In-Kind Donation',
  Stock: 'Stock Donation',
  Crypto: 'Crypto Donation',
};
